/**
 * 应用路由配置
 */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import App from './App';
import Home from './pages/Home';
import Login from './pages/Login';  // 新增
import Loading from './pages/Loading';  // 微信登录加载页
import InviteAccept from './pages/InviteAccept';  // 邀请链接处理页面

function AppRouter() {
  return (
    <Routes>
      {/* 登录页 */}
      <Route path="/login" element={<Login />} />

      {/* 微信登录加载页（iframe 内使用） */}
      <Route path="/loading" element={<Loading />} />

      {/* 首页：产品介绍 + 新手引导 */}
      <Route path="/" element={<Home />} />

      {/* 邀请链接处理 */}
      <Route path="/invite" element={<InviteAccept />} />

      {/* 项目管理列表 */}
      <Route path="/projects" element={<App initialView="project-management" />} />

      {/* 新建标书向导 */}
      <Route path="/create" element={<App initialView="new-project" />} />

      {/* 项目编辑页 - 支持 URL 直接访问 */}
      <Route path="/project/:projectId" element={<App initialView="new-project" />} />

      {/* 模板管理及详情 */}
      <Route path="/templates" element={<App initialView="template-management" />} />
      <Route path="/templates/:id" element={<App initialView="template-management" />} />

      {/* 主体管理及详情 */}
      <Route path="/companies" element={<App initialView="company-management" />} />
      <Route path="/companies/:id" element={<App initialView="company-management" />} />
      <Route path="/companies/new" element={<App initialView="company-edit" />} />
      <Route path="/companies/:id/edit" element={<App initialView="company-edit" />} />

      {/* 资源管理及详情 */}
      <Route path="/resources" element={<App initialView="resource-management" />} />
      <Route path="/resources/:id" element={<App initialView="resource-management" />} />

      {/* Token管理 */}
      <Route path="/tokens" element={<App initialView="token-management" />} />

      {/* 人员管理 */}
      <Route path="/users" element={<App initialView="user-management" />} />

      {/* 项目组管理 */}
      <Route path="/project-groups" element={<App initialView="project-group-management" />} />
    </Routes>
  );
}

export default AppRouter;
